import React from "react";
import "./CustomSwitch.css";

const CustomSwitch = ({ checked, onChange, disabled = false }) => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        className="SwInput"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="slider" />
    </label>
  );
};

export default CustomSwitch;
